module.exports = __webpack_public_path__ + "img/presidentialsweet_room_feature03.b8060cf1.jpg";